/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import Plx from 'react-plx';

import { Grid, Typography } from '@mui/material';

import { Namespaces } from '../../../../i18n';
import { createOurOfficesSectionStyles } from './OurOfficesSection.styles';

const parallaxData = [
  {
    start: '.plxOurOffices',
    duration: '40vh',
    properties: [
      {
        startValue: -40,
        endValue: 0,
        unit: 'vh',
        property: 'translateY',
      },
      {
        startValue: 0,
        endValue: 1,
        property: 'opacity',
      },
    ],
  },
];

export const OurOfficesSection = memo(() => {
  const classes = createOurOfficesSectionStyles();
  const { t } = useTranslation(Namespaces.About);

  const list = [
    '\uD83C\uDF10',
    '\uD83C\uDDE8\uD83C\uDDED',
    '\uD83C\uDDEA\uD83C\uDDEA',
    '\uD83C\uDDFA\uD83C\uDDFE',
    '\uD83C\uDDFF\uD83C\uDDE6',
  ];

  return (
    <div className={classes.root}>
      <Plx className={cx('plxOurOffices', classes.plxOurOffices)} parallaxData={parallaxData}>
        <Typography variant="h1" classes={{ h1: classes.title }}>
          {t('offices.title')}
        </Typography>
        <Grid container classes={{ root: classes.container }} spacing={5}>
          {list.map((item, i) => {
            return (
              <Grid item key={i} lg={4} md={6}>
                <Typography variant="h2" classes={{ root: classes.itemTitle }}>
                  <span role="img" aria-label={t(`offices.item_${i + 1}.title`)}>
                    {item}
                  </span>
                  {t(`offices.item_${i + 1}.title`)}
                </Typography>
                <Typography variant="body1" component={'div'} classes={{ body1: classes.itemListItem }}>
                  <p>{t(`offices.item_${i + 1}.line_1`)}</p>
                  <p>{t(`offices.item_${i + 1}.line_2`)}</p>
                  <p>{t(`offices.item_${i + 1}.line_3`)}</p>
                  <p>{t(`offices.item_${i + 1}.line_4`)}</p>
                  <p>{t(`offices.item_${i + 1}.line_5`)}</p>
                  <p>{t(`offices.item_${i + 1}.line_6`)}</p>
                </Typography>
              </Grid>
            );
          })}
        </Grid>
      </Plx>
    </div>
  );
});
